var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer" },
    [
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column is-9" }, [
            _c("p", { staticClass: "title has-text-primary" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$store.state.customers.temporal.rfc) +
                  "\n        "
              )
            ]),
            _c("p", { staticClass: "title has-text-primary" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$store.state.customers.temporal.name) +
                  "\n        "
              )
            ])
          ]),
          _c("div", { staticClass: "column level-right" }, [
            _c("div", { staticClass: "columns" }, [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "column" },
                _vm._l(
                  _vm.$store.state.customers.temporal.debtsCustomer,
                  function(debt) {
                    return _c(
                      "p",
                      {
                        key: debt._id.customer,
                        staticClass: "is-4 title has-text-info level-left"
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("toCurrency")(
                                debt.totalAmount,
                                debt._id.currency
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  }
                ),
                0
              )
            ]),
            _c("div", { staticClass: "columns" }, [
              _vm._m(1),
              _c(
                "div",
                { staticClass: "column" },
                _vm._l(
                  _vm.$store.state.customers.temporal.debtsExpired,
                  function(debt) {
                    return _c(
                      "p",
                      {
                        key: debt._id.customer,
                        staticClass: "title is-4 has-text-danger level-left"
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("toCurrency")(
                                debt.totalAmount,
                                debt._id.currency
                              )
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  }
                ),
                0
              )
            ]),
            _vm.$store.state.customers.temporal.creditLimit > 0
              ? _c("div", { staticClass: "columns" }, [
                  _vm._m(2),
                  _c(
                    "div",
                    { staticClass: "column" },
                    _vm._l(
                      _vm.$store.state.customers.temporal.debtCreditLimit,
                      function(debt) {
                        return _c(
                          "p",
                          {
                            key: debt._id.customer,
                            staticClass: "is-4 title has-text-info level-left"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("toCurrency")(
                                    _vm.$store.state.customers.temporal
                                      .creditLimit - debt.totalAmount,
                                    "MXN"
                                  )
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      }
                    ),
                    0
                  )
                ])
              : _vm._e()
          ])
        ])
      ]),
      _c("div", { staticClass: "columns is-multiline" }, [
        _c("div", { staticClass: "column is-5" }, [
          _c("div", { staticClass: "box" }, [
            _c("section", { staticClass: "modal-card-body" }, [
              _c("div", { staticClass: "columns is-multiline" }, [
                _c(
                  "div",
                  { staticClass: "column is-12" },
                  [
                    _vm.loaded
                      ? _c("Customer", { attrs: { loading: _vm.loading } })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "column" }, [
          _c(
            "div",
            { staticClass: "box" },
            [
              _vm.loaded
                ? _c("IssoComments", {
                    staticClass: "box",
                    attrs: { loading: _vm.loading }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _c("InvoicesHistory")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-4" }, [
      _c("p", { staticClass: "title is-4 has-text-primary level-left" }, [
        _vm._v("\n              Deuda total\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-4" }, [
      _c("p", { staticClass: "title is-4 has-text-primary level-left" }, [
        _vm._v("\n              Deuda vencida\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-4" }, [
      _c("p", { staticClass: "title is-4 has-text-primary level-left" }, [
        _vm._v("\n              Crédito disponible\n            ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }